import { AcoItemConenetType } from "@/utils/schema/quote-page-schema.utils";

const getAcoData = (data: Record<string, AcoItemConenetType> | undefined) => {
  if (data === undefined) return [];
  const keys = Object.keys(data);
  return keys?.map((node) => {
    return {
      code: data[node].acoId,
      data: {
        acoTitle: data[node].acoTitle,
        description: data[node].description,
        drawerContent: data[node].drawerContent,
        drawerCloseCta: data[node].drawerCloseCta,
        removeModalTitle: data[node].removeModalTitle,
        removeModalDescription: data[node].removeModalDescription,
        removeModalCancelCTALabel: data[node].removeModalCancelCTALabel,
        removeModalConfirmCTALabel: data[node].removeModalConfirmCTALabel,
        isExcludeSameCountryTravel: data[node].isExcludeSameCountryTravel,
        isGolfCover: data[node].acoId === "GOLF_EQUIPMENT",
        isSingleItemCover: data[node].acoId === "SINGLE_ITEM_COVER",
        isTravelDisruptionCover: data[node].acoId === "TDE",
        isTravelDisruption: data[node].acoId === "TDE",
      },
    };
  });
};

export default getAcoData;
